import { createFileRoute } from "@tanstack/react-router";

import { LoadingIcon } from "@web-app/components";
import { useApp } from "@web-app/hooks";
import ChatEventsProvider from "@web-app/pages/chatPage/ChatEventsProvider";
import CostOptimizerPage from "@web-app/pages/costOptimizer";

export const Route = createFileRoute("/cpd/")({
  component: CostOptimizer,
});

function CostOptimizer() {
  const { sessionUser, isLoading, logout } = useApp();

  if (isLoading || !sessionUser) {
    return (
      <div className="h-screen w-screen grid place-content-center">
        <LoadingIcon className="w-8 h-8" />
      </div>
    );
  }

  return (
    <ChatEventsProvider>
      <CostOptimizerPage logout={logout} />
    </ChatEventsProvider>
  );
}
